// extracted by mini-css-extract-plugin
export default {"modal":"jda-z","modalContent":"kda-z","footer":"lda-z","cancelBtn":"mda-z","disabled":"nda-z","formWrapper":"oda-z","fade":"pda-z","fade-in":"qda-z","iframe":"rda-z"};